// кука ответственная за управление отображением банера
export const KEY_COOKIE = 'lt_go_to_app_mobile_desktop';
// id для тестирования через testing-library
export const DATA_TEST_ID = 'desktop-app-banner';
// id для тестирования кнопки закрытия
export const BUTTON_DATA_TEST_ID = 'desktop-app-banner-button';
